export default __webpack_public_path__ + "static/media/Cancel Block_Dark2.43a5de02.svg";